import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { card, h1, badge, fmtDate } from "./ui";
import { Mail, Phone, Check, CalendarClock, UserPlus, UserCheck } from "lucide-react";

export default function Messages() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(null);

  const load = () => api.get("/contact").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.patch(`/contact/${id}/read`);
    load();
  };

  const registerPatient = async (m) => {
    setBusy(m.id);
    try {
      const { data } = await api.post(`/contact/${m.id}/register-patient`);
      toast.success(data.already ? `${data.name} já estava cadastrado(a).` : `Paciente ${data.name} cadastrado(a)!`);
      load();
    } catch {
      toast.error("Não consegui cadastrar o paciente.");
    } finally { setBusy(null); }
  };

  return (
    <div data-testid="messages-page">
      <p className="font-body text-xs tracking-[0.35em] uppercase text-[#C87A5E]">Mensagens</p>
      <h1 className={h1}>Caixa de entrada</h1>
      <p className="font-body text-[#4A5D4E] mt-2">Mensagens enviadas pelo formulário de contato do site.</p>

      <div className="mt-8 space-y-4">
        {items.length === 0 && <p className="font-body text-sm text-[#7A8A7A]">Nenhuma mensagem ainda.</p>}
        {items.map((m) => (
          <div key={m.id} className={`${card} p-6`} data-testid="message-card">
            <div className="flex items-start justify-between flex-wrap gap-3">
              <div>
                <p className="font-display text-xl text-[#2C332A] flex items-center gap-3">
                  {m.name}
                  {!m.read && <span className={badge(false)}>nova</span>}
                  {m.patient_registered && <span className="inline-flex items-center gap-1 rounded-full bg-[#5B6E5B]/12 px-2.5 py-0.5 text-xs text-[#4A5D4E]"><UserCheck className="w-3 h-3" /> paciente</span>}
                </p>
                <div className="flex flex-wrap gap-4 mt-2 font-body text-sm text-[#7A8A7A]">
                  <span className="flex items-center gap-1.5"><Mail className="w-3.5 h-3.5" /> {m.email}</span>
                  {m.phone && <span className="flex items-center gap-1.5"><Phone className="w-3.5 h-3.5" /> {m.phone}</span>}
                </div>
              </div>
              <div className="flex items-center gap-3">
                {!m.read && (
                  <button onClick={() => markRead(m.id)} className="inline-flex items-center gap-1.5 text-sm text-[#5B6E5B] hover:text-[#2C332A]" data-testid="mark-read">
                    <Check className="w-4 h-4" /> Marcar como lida
                  </button>
                )}
              </div>
            </div>

            {m.slot_date && m.slot_time && (
              <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#C87A5E]/10 px-3.5 py-1.5" data-testid="message-slot">
                <CalendarClock className="w-4 h-4 text-[#C87A5E]" />
                <span className="font-body text-sm text-[#B2644D]">Horário de interesse: {fmtDate(m.slot_date)} às {m.slot_time}</span>
              </div>
            )}

            <p className="font-body text-[#4A5D4E] mt-4 leading-relaxed whitespace-pre-line">{m.message}</p>

            <div className="mt-4 pt-4 border-t border-[#5B6E5B]/10">
              {m.patient_registered ? (
                <span className="inline-flex items-center gap-1.5 font-body text-sm text-[#5B6E5B]"><UserCheck className="w-4 h-4" /> Já cadastrado como paciente</span>
              ) : (
                <button onClick={() => registerPatient(m)} disabled={busy === m.id} data-testid="register-patient-btn"
                  className="inline-flex items-center gap-2 rounded-full bg-[#5B6E5B] px-4 py-2 text-sm text-[#FDFBF7] hover:bg-[#4A5D4E] transition-colors disabled:opacity-60">
                  <UserPlus className="w-4 h-4" /> Cadastrar como paciente
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
